import { useAnalyticsDataProviderContext } from "../AnalyticsDataProvider";
// import AudienceTable from "./AudienceTable";
import AudienceTableNew from "./AudienceTablePOC";

function AudienceAnalytics() {
  const { audienceAnalyticsDataLoading, audienceAnalyticsData, handleExportAudienceData } =
    useAnalyticsDataProviderContext();

  if (audienceAnalyticsDataLoading) {
    return null;
  }

  if (!audienceAnalyticsData) {
    return null;
  }

  return <AudienceTableNew data={audienceAnalyticsData} handleExport={handleExportAudienceData} />;
}
export default AudienceAnalytics;
